export const state = () => ({
  addresses: {},
  amounts: {},
  apiTokens: null,
  banking: {},
  energyValues: null,
  filterDisplay: false,
  filterExtraDisplay: false,
  flash: {},
  formErrors: {},
  formErrorScrolled: false,
  meta: null,
  pagination: { current_page: 0, limit_value: 0, total_count: 0, total_pages: 0 },
  windowWidth: null,
  userMessage: ''
});

export const mutations = {
  clearAddress (state, key) {
    const addresses = { ...state.addresses };
    delete addresses[key || 'default'];
    state.addresses = addresses;
  },
  clearBankingFields (state, fields) {
    fields.forEach(f => delete state.banking[f]);
  },
  clearFormError (state, key) {
    delete state.formErrors[key];
  },
  clearFormErrors (state) {
    state.formErrors = {};
    state.formErrorScrolled = false;
  },
  clearMeta (state) {
    state.meta = null;
  },
  setAddress (state, address) {
    if (!address) {
      return;
    }
    const key = address.key ? address.key : 'default';

    delete address.key;
    if (!address.county) address.county = '';
    const addresses = { ...state.addresses };
    addresses[key] = { ...state.addresses[key], ...address };
    state.addresses = addresses;
  },
  setAmounts (state, amounts) {
    state.amounts = amounts || {};
  },
  setApiTokens (state, token) {
    state.apiTokens = token;
  },
  setBanking (state, banking) {
    state.banking = { ...state.banking, ...banking };
  },
  setEnergyValues (state, values) {
    state.energyValues = values;
  },
  setFilterDisplay (state, display) {
    state.filterDisplay = display;
  },
  setFilterExtraDisplay (state, display) {
    state.filterExtraDisplay = display;
  },
  setFlash (state, flash) {
    state.flash = flash || {};
  },
  setFormErrors (state, formErrors) {
    state.formErrors = { ...state.formErrors, ...formErrors };
  },
  setFormErrorScrolled (state, value) {
    state.formErrorScrolled = value;
  },
  setMeta (state, meta) {
    state.meta = { ...state.meta, ...meta };
  },
  setPagination (state, pagination) {
    state.pagination = pagination;
  },
  setWindowWidth (state, width) {
    state.windowWidth = width;
  },
  setUserMessage (state, userMessage) {
    state.userMessage = userMessage;
  }
};

export const getters = {
  getAddress: (state) => (key) => {
    return state.addresses[key || 'default'] || {};
  },
  getAmounts (state) {
    return state.amounts;
  },
  getApiTokens (state) {
    return state.apiTokens;
  },
  getBanking (state) {
    return state.banking;
  },
  getBankBranch (state) {
    return state.bankBranch;
  },
  getCheapestBroadband (state) {
    return state.amounts.cheapest_broadband || 0;
  },
  getEnergySavings (state) {
    return state.amounts.energy_saving || 0;
  },
  getFilterDisplay (state) {
    return state.filterDisplay;
  },
  getFilterExtraDisplay (state) {
    return state.filterExtraDisplay;
  },
  getFlash (state) {
    return state.flash;
  },
  getFormErrorByKey: (state) => (key) => {
    return state.formErrors[key] || null;
  },
  getFormErrors (state) {
    return state.formErrors;
  },
  getFormErrorScrolled (state) {
    return state.formErrorScrolled;
  },
  getMeta (state) {
    return state.meta;
  },
  getPagination (state) {
    return state.pagination;
  },
  getProductFromMeta (state, getters) {
    return (getters.getMeta && getters.getMeta.product) || null;
  },
  getRoute (state) {
    return state.route;
  },
  getUserMessage (state) {
    return state.userMessage;
  },
  isDesktop (state) {
    return state.windowWidth > 1023;
  },
  isTablet (state) {
    return state.windowWidth > 992;
  },
  windowWidth (state) {
    return state.windowWidth;
  }
};

export const actions = {
  flashMessage ({ commit }, flash) {
    commit('setFlash', flash);
    setTimeout(() => commit('setFlash'), 3000);
  }
};
